import { Link } from "react-router-dom";
import { useState } from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import OutterLeftPanel from "../../../components/OutterLeftPanel";
import abgLogo from "../../../assets/imgs/blue-logo.svg";
import AuthInput from "../../../components/authentication-input/AuthInput";

export function ForgotPassword() {
  const [isResetLinkClicked, setIsResetLinkClicked] = useState(false);
  const [email, setEmail] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);

  const emailValue = email.trim();
  const emailFormatValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  const isEmailValid = emailValue.length > 0 && emailFormatValid;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setIsResetLinkClicked(true);
  };

  const handleResendEmail = () => {
    // Intentionally no logging of the user's email address (PII, CWE-532).
    // TODO: wire up to the resend-reset-link API.
  };

  return (
    <div className="min-h-[100svh] bg-[#ECEEF3] p-5">
      <div className="mx-auto flex h-[calc(100svh-40px)] min-h-[720px] gap-8 rounded-[24px]">
        <div className="flex w-1/2 items-center justify-center">
          <div className="w-full max-w-[440px] rounded-[7px] bg-white px-7 py-7">
            <div className="relative mb-8 flex w-full items-center">
              <img
                src={abgLogo}
                alt="ABG | accord business group"
                className="h-6 w-auto object-contain"
              />
              <span className="absolute left-1/2 -translate-x-1/2 text-[20px] font-bold text-[#6F7F96]">
                Mynd
              </span>
            </div>

            {isResetLinkClicked ? (
              <>
                <h2 className="mb-7 text-[20px] font-bold text-[#6F7F96]">
                  Check Your Email
                </h2>

                <p className="mb-4 text-sm text-gray-600">
                  A reset link has been sent to <strong>{email}</strong>. Please
                  check your inbox and follow the instructions to reset your
                  password.
                </p>

                <div className="mt-8 text-center">
                  <p className="text-sm text-gray-600">
                    Didn't receive the email?
                    <button
                      onClick={handleResendEmail}
                      className="ml-2 font-medium text-[#2D2EFF] hover:text-[#2424CC] hover:underline"
                    >
                      Resend Link
                    </button>
                  </p>
                </div>
              </>
            ) : (
              <>
                <h2 className="mb-7 text-[20px] font-extrabold text-[#6F7F96]">
                  AI That Thinks With You
                </h2>

                <form className="space-y-4" onSubmit={handleSubmit}>
                  <AuthInput
                    label="Email Address"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={setEmail}
                    leftIcon={<MailOutlineIcon sx={{ fontSize: 18, display: "block" }} />}
                    isValid={isEmailValid}
                    touched={emailTouched}
                    setTouched={setEmailTouched}
                    inputTextColorClassName="text-[#32445A]"
                    required
                  />

                  <p className="text-sm text-gray-500 mt-2 mb-4">
                    Please enter your email address to reset your password.
                  </p>

                  <button
                    type="submit"
                    className="h-[40.7px] w-full rounded-[8px] bg-[#3538FF] text-[16px] font-semibold text-white transition hover:bg-[#2D2EFF]"
                  >
                    Send Reset Link
                  </button>
                </form>

                <div className="mt-8 text-center">
                  <p className="text-sm text-gray-600">
                    Remembered your password?
                    <Link
                      to="/login"
                      className="ml-2 font-medium text-[#2D2EFF] hover:text-[#2424CC] hover:underline"
                    >
                      Login
                    </Link>
                  </p>
                </div>
              </>
            )}
          </div>
        </div>

        <OutterLeftPanel />
      </div>
    </div>
  );
}